"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const plan_1 = __importDefault(require("./plan"));
const planGroup_1 = __importDefault(require("./planGroup"));
class Formatter {
    formatSignupPlanSelectedForClick() {
        const signupPlans = $("#signupplans .inpplan").val();
        let selectedPlan = "";
        // Set
        if (signupPlans == "1" || signupPlans == "2") {
            selectedPlan = "small-business";
        }
        else if (signupPlans == "3" || signupPlans == "4") {
            selectedPlan = "professional";
        }
        return selectedPlan;
    }
    formatSignupPlanSelected() {
        const ccPlan = $("#creditcardform .inpplan").val();
        let upgradeSelectPlan = "hobby";
        // Set
        if (ccPlan == "1" || ccPlan == "2") {
            upgradeSelectPlan = "small-business";
        }
        else if (ccPlan == "3" || ccPlan == "4") {
            upgradeSelectPlan = "professional";
        }
        return upgradeSelectPlan;
    }
    formUpgradePlanSchedule() {
        let schedule = "";
        const selectedCycle = $("#pypo-form .inpplan_cycle").val();
        if (selectedCycle == "1") {
            schedule = "monthly";
        }
        else if (selectedCycle == "2") {
            schedule = "annual";
        }
        return schedule;
    }
    formatUpgradePlanId() {
        const selectedPlan = $("#pypo-form .inpplan").val();
        if (typeof selectedPlan === "string") {
            return selectedPlan;
        }
        return "";
    }
    formatUpgradePlanSelected() {
        const selectedPlanId = this.formatUpgradePlanId();
        let tmpPln = "";
        if (selectedPlanId == "1" || selectedPlanId == "2") {
            tmpPln = "small-business";
        }
        else if (selectedPlanId == "3" || selectedPlanId == "4") {
            tmpPln = "professional";
        }
        return tmpPln;
    }
    formatSignupFlowPath() {
        let flowPath = "standard";
        const queryParams = new URLSearchParams(window.location.search);
        if (window.location.href.includes("/signup/hobby") &&
            queryParams.get("domain") != null &&
            queryParams.get("domain") != "") {
            flowPath = "hobby-domain";
        }
        else if (window.location.href.includes("/signup/hobby")) {
            flowPath = "hobby";
        }
        else if (window.location.href.includes("/signup/small-business")) {
            flowPath = "small-business";
        }
        else if (window.location.href.includes("/signup/professional")) {
            flowPath = "professional";
        }
        else if (window.location.href.includes("/signup/enterprise")) {
            flowPath = "enterprise";
        }
        return flowPath;
    }
    getSignupPlanId() {
        const planId = $("#signupplans .inpplan").val();
        return typeof planId === "string" ? planId : "";
    }
    getSignupPlanData() {
        const formPlanType = $("#form-selectplan").attr("data-plan");
        let items = [];
        if (typeof amplitudePlanMap !== "undefined" &&
            amplitudePlanMap.length > 0) {
            for (let i = 0; i < amplitudePlanMap.length; i++) {
                if (amplitudePlanMap[i].plan_type_name.replace(" ", "") === formPlanType) {
                    items.push(new plan_1.default(amplitudePlanMap[i]));
                }
            }
        }
        const isYearly = $("#form-selectplan .plan_frequency").prop("checked");
        if (items.length > 1 && isYearly) {
            items = items.filter((item) => item.isAnnual());
        }
        else if (items.length > 1) {
            items = items.filter((item) => !item.isAnnual());
        }
        if (items.length < 1) {
            return null;
        }
        return items[0];
    }
    getCurrentPlanGroupData() {
        if (typeof amplitudePlanGroup === "undefined") {
            return null;
        }
        return new planGroup_1.default(amplitudePlanGroup);
    }
}
exports.default = Formatter;
